module.exports = __webpack_public_path__ + "assets/media/client-3.d30f0693.svg";